import type { ExcipientRequirementOption } from './api.ts'

/**
 * The excipient section's small decisions (#617), kept out of the product page
 * so they are tested without rendering it.
 */

/** The requirements chosen, in the order the server lists them. */
export function withAnswer(
  chosen: readonly string[],
  id: string,
  on: boolean,
  requirements: readonly ExcipientRequirementOption[],
): string[] {
  const next = new Set(chosen)
  if (on) next.add(id)
  else next.delete(id)
  return requirements.map((one) => one.id).filter((one) => next.has(one))
}

/** The screen's word for each answer, falling back to the id. */
export function answerLabels(
  answers: readonly string[],
  requirements: readonly ExcipientRequirementOption[],
): string[] {
  return answers.map((id) => requirements.find((one) => one.id === id)?.label ?? id)
}

/**
 * What saving the boxes does: nothing when they match what is stored, a
 * removal when none is ticked -- indicated for nothing is no opinion -- and
 * otherwise a replacement.
 */
export function answerChange(
  saved: readonly string[],
  chosen: readonly string[],
): 'none' | 'clear' | 'set' {
  const same = saved.length === chosen.length && saved.every((one) => chosen.includes(one))
  if (same) return 'none'
  return chosen.length === 0 ? 'clear' : 'set'
}
